import React from "react";
import trans from "../../../../utils";
import { Input, TextAreaInput } from "../../../Helpers/Input/Input";

export default function PermissionsInfo({ addData }) {
	return (
		<>
			<div className="userinfo mb-24">
				<p className="fs-16 fw-700 brand-700 text-uppercase">
					{trans("general information")}
				</p>
				<div className="row">
					<div className="col-lg-12">
						<Input
							title={trans("Name")}
							type="text"
							placeholder={trans("e.g., View Attendance Records")}
							formstyle="form-input"
							id="name"
							name="name"
							onBlur={addData.handleBlur}
							onChange={addData.handleChange}
							errors={addData.errors.name}
							touched={addData.touched.name}
							value={addData.values.name || ""}
						/>
					</div>
					<div className="col-lg-12">
						<TextAreaInput
							title={trans("Description")}
							type="text"
							placeholder={trans("Describe what this permission allows")}
							formstyle="form-input"
							id="description"
							name="description"
							rows={3}
							onBlur={addData.handleBlur}
							onChange={addData.handleChange}
							errors={addData.errors.description}
							touched={addData.touched.description}
							value={addData.values.description || ""}
						/>
					</div>
				</div>
			</div>
		</>
	);
}
